import { render } from "./CustomInput.vue?vue&type=template&id=4bb48d70"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__